const o = "#0F6EFF", n = "#38C83E", t = "#FFA41E", c = "#FA4F43", r = "#FFFFFF", F = "#000000", a = "#F4F4F4", s = "#102027", d = "#E7E8E9", y = "#D9DBDC", e = "#9FA6A9", l = "#6B7579", i = "#324046", k = "rgba(15, 110, 255, 0.4)", E = "#e7e8e9", b = o, g = n, G = t, A = c, _ = o, u = s, D = e, p = "#1890FF", C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CARD_BLUE: k,
  CARD_GREY: E,
  black: F,
  blue: o,
  darkGrey: s,
  darkGrey10: d,
  darkGrey16: y,
  darkGrey40: e,
  darkGrey62: l,
  darkGrey86: i,
  disabled: D,
  error: A,
  green: n,
  info: b,
  light: p,
  orange: t,
  primary: _,
  red: c,
  secondary: u,
  sky: a,
  success: g,
  warning: G,
  white: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  k as CARD_BLUE,
  E as CARD_GREY,
  F as black,
  o as blue,
  C as colors,
  s as darkGrey,
  d as darkGrey10,
  y as darkGrey16,
  e as darkGrey40,
  l as darkGrey62,
  i as darkGrey86,
  D as disabled,
  A as error,
  n as green,
  b as info,
  p as light,
  t as orange,
  _ as primary,
  c as red,
  u as secondary,
  a as sky,
  g as success,
  G as warning,
  r as white
};
//# sourceMappingURL=index-B_SF5K6P.js.map
